/**
 * Hash Utilities for Image Deduplication
 *
 * Provides simple hash functions for content-based deduplication.
 */
/**
 * Simple hash function for deduplication.
 * Creates a deterministic hash from a string input.
 *
 * @param str - Input string to hash
 * @returns Hash string in base36 format
 */
export function simpleHash(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash).toString(36);
}
/**
 * Generate a content hash for image deduplication.
 * For very large strings, samples the content for faster hashing.
 *
 * @param content - Content to hash (base64 string or other content)
 * @returns Hash string
 */
export function contentHash(content) {
    // For large content (e.g., base64 images), sample for faster hashing
    if (content.length > 100000) {
        // Sample: first 1000 chars + middle 1000 chars + last 1000 chars + length
        const sample = content.substring(0, 1000) +
            content.substring(Math.floor(content.length / 2) - 500, Math.floor(content.length / 2) + 500) +
            content.substring(content.length - 1000) +
            content.length.toString();
        return simpleHash(sample);
    }
    return simpleHash(content);
}
